import { call } from "./use";

export const useResize = (controller, options = {}) => {
  const controllerDisconnect = controller.disconnect.bind(controller);
  const targetElement = options?.element || controller.element;

  const callback = (entries) => {
    window.requestAnimationFrame(() => {
      if (!entries.length) return;
      const [entry] = entries;
      call(controller, "resize", entry.contentRect);
    });
  };

  const observer = new ResizeObserver(callback);
  const observe = () => observer.observe(targetElement);
  const unobserve = () => observer.unobserve(targetElement);

  Object.assign(controller, {
    disconnect() {
      unobserve();
      controllerDisconnect();
    },
  });

  observe();

  // First call
  callback([targetElement.getBoundingClientRect()]);

  return [observe, unobserve];
};
